module.exports = __webpack_public_path__ + "img/logo2.fc048282.png";